import { toDiscountCodePayload } from "../form";
import View from "./View";

const Detail = ({ updateDiscountCode, setOpenDetail, openDetail }) => {
  const onClose = () => setOpenDetail({});

  const onSubmit = (data) => {
    return updateDiscountCode({
      variables: {
        where: { id: openDetail && openDetail.id },
        data: toDiscountCodePayload(data),
      },
    });
  };

  return <View onSubmit={onSubmit} onClose={onClose} open={openDetail} />;
};

export default Detail;
